<script>
import { redirectToRegistration } from "../../helpers/routerHelper";
import box from "../../utils";
import { mapActions } from "vuex";

export default {
  name: "signInSection",
  data() {
    return {
      email: "",
      password: "",
      emailOnResetPassword: "",
      viewPassword: false,
      passwordResetDialogVisible: false,
      resetEmailSentDialogVisible: false
    };
  },
  beforeUpdate() {
    document.title = "UNIFI Property: Login";
  },
  methods: {
    ...mapActions("login", ["signIn", "forgot", "getUrl"]),
    redirectToRegistration,
    handleClosePasswordReset() {
      this.passwordResetDialogVisible = false;
    },
    handleCloseResetEmailSent() {
      this.resetEmailSentDialogVisible = false;
    },
    login() {
      console.log("Login");
      var that = this;
      if (that.disableLogin) {
        return false;
      }
      that.$box.loadings(3);
      that.signIn({
        params: { email: that.email, password: that.password },
        callback: that.callback
      });
    },
    callback(res) {
      console.log("callback login");
      var that = this;
      that.$box.loadings(2);
      if (res.data.code == 0) {
        ga(
          "send",
          "event",
          "login",
          that.email,
          res.data.data.firstName + " " + res.data.data.lastName
        );
        var previousPath = localStorage.getItem('previousPath');
        localStorage.clear();
        // 保存token在本地
        localStorage.setItem("token", res.data.data.token);
        // 带参跳转
        localStorage.setItem("flagPass", res.data.data.flagPass);
        localStorage.setItem("flagAgreement", res.data.data.flagAgreement);
        localStorage.setItem("mode", "off");
        if (previousPath) {
          that.$router.replace(previousPath);
        } else {
          that.$router.replace("/homepage");
        }
        // that.$router.go(-1) // this is used to redirect to the previous page that was in before login cause registered users need to redirect to the same page before logged in
      } else if (res.data.code == 70010) {
        that.warn2 = true;
      } else if (res.data.code == 40007) {
        that.warn = true;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    submit() {
      console.log("Forget password");
      var that = this;
      if (
        that.emailOnResetPassword == null ||
        that.emailOnResetPassword == ""
      ) {
        that.$box.alert("", "Please fill the email address", "error");
        return;
      }
      // NOTE:  if you see 2 emails being sent out, then probably your dev database is on the production server
      that.$box.loadings();
      console.log("submit the forgot password code1");
      that.forgot({
        params: { email: that.emailOnResetPassword },
        callback: that.forgotCallback
      });
    },
    forgotCallback(res) {
      console.log("call back the forgot password code1");
      var that = this;
      that.$box.loadings(2);
      if (res.data.code == 0) {
        that.haveSubmit = true;
        that.forget();
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    forget() {
      console.log("Forget password");
      this.passwordResetDialogVisible = false;
      // box.alert('', 'The email you have entered is not recognised.' ,'error');
      // this.$message('', 'An email has been sent to you with a link to reset your password!' ,'success');
      this.resetEmailSentDialogVisible = true;
    },
    ucallback(res) {
      if (res.data.code == 0) {
        res.data.data.forEach(v => {
          if (v.type == 1) {
            this.link = v.url;
          }
        });
      }
    },
    validate() {
      //need to figure out which type of validation I want to do
      // Ideally grey out the submitt button until the fields are validated.
      var that = this;
      if (that.email == "") {
        that.warn = false;
        return;
      }
      var reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      if (reg.test(that.email)) {
        that.warn = false;
      } else {
        that.warn = true;
      }
    }
  },
  created() {
    sessionStorage.clear();
    this.getUrl({ callback: this.ucallback });
  },
  mounted() {
    var _timer = setTimeout(() => {
      this.ready = true;
      clearTimeout(_timer);
      _timer = null;
    });
  }
};
</script>

<template>
  <el-row class="create-account-section">
    <el-col :span="24">
      <img
        class="create-account-background"
        loading="lazy"
        src="../../assets/AgentLoginBackground.jpg"
      />
      <div class="sign-in-outer-wrapper">
        <el-row class="sign-in-inner-wrapper" >

            <el-col :span="24" class="sign-in-title-wrapper">
              <span class="sign-in-title">Sign in</span>
            </el-col>

          <el-col :span="24" class="sign-in-form-wrapper">
           <div style="background-color: #ffffff; border-radius: 0 0 15px 15px; padding: 0 16px 30px 16px">
             <el-form class="sign-in-form">
               <el-row style="width: 100%">
                 <el-col :span="24" style="padding: 16px 0">
                   <el-input v-model="email" placeholder="Email Address">
                     <template slot="prepend"
                     ><i class="el-icon-edit-outline"
                     /></template>
                   </el-input>
                 </el-col>
               </el-row>
               <el-row style="width: 100%">
                 <el-col :span="24" style="padding-bottom: 16px">
                   <el-input
                     id="passwordfield"
                     v-model="password"
                     placeholder="Password"
                     v-bind:type="viewPassword ? 'text' : 'password'"
                     @keyup.enter.native="login"
                   >
                     <template slot="prepend"><i class="el-icon-lock"/></template>
                     <template v-if="viewPassword" slot="append"
                     ><i class="el-icon-view" @click="viewPassword = !viewPassword"
                     /></template>
                     <template v-if="!viewPassword" slot="append"
                     ><i
                     ><img
                       class="icon-hide"
                       src="../../assets/el-icon-hide.svg"
                       @click="viewPassword = !viewPassword"/></i
                     ></template>
                   </el-input>
                 </el-col>
               </el-row>
               <el-row style="width: 100%">
                 <el-col
                   :span="24"
                   style="padding-bottom: 16px; display: flex; flex-direction: column"
                 >
                   <el-button class="btn-primary" @click="login">Login</el-button>
                 </el-col>
               </el-row>

             </el-form>
           </div>
            <el-row>
              <el-col
                :span="4" :offset="20"
                style="display: flex; flex-direction: column"
              >
                <el-button
                  class="btn-underline"
                  type="text"
                  @click="passwordResetDialogVisible = true"
                >Forgot password?
                </el-button>
                <el-dialog
                  :before-close="handleClosePasswordReset"
                  :visible.sync="passwordResetDialogVisible"
                  center
                  style="margin: 15% 0"
                  width="90%"
                >
                  <span
                    slot="title"
                    :style="{
                      fontSize: '34px',
                      color: '#101010',
                      fontFamily: 'Metropolis',
                      fontStyle: 'normal',
                      fontWeight: '600',
                      lineHeight: '117.647%',
                      display: 'flex',
                      justifyContent: 'start'
                    }"
                  >Forgot password</span>
                  <span class="forgotPasswordSpan"
                  >Provide your account email address to receive an email to reset
                your password.</span
                  >
                  <el-input
                    v-model="emailOnResetPassword"
                    class="forgotPasswordInput"
                    placeholder="Email Address"
                  >
                    <template slot="prepend"
                    ><i class="el-icon-edit-outline"
                    /></template>
                  </el-input>
                  <span
                    slot="footer"
                    class="dialog-footer forgotPasswordInputSpanBtn"
                  >
                  <el-button
                    class="forgotPasswordBtn"
                    type="primary"
                    @click="submit"
                  >Submit</el-button>
                </span>
                </el-dialog>
                <el-dialog
                  :before-close="handleCloseResetEmailSent"
                  :visible.sync="resetEmailSentDialogVisible"
                  center
                  style="margin: 15% 0"
                  width="90%"
                >
                  <span
                    slot="title"
                    :style="{
                      fontSize: '34px',
                      color: '#101010',
                      fontFamily: 'Metropolis',
                      fontStyle: 'normal',
                      fontWeight: '600',
                      lineHeight: '117.647%',
                      display: 'flex',
                      justifyContent: 'start'
                    }"
                  >Please Check Your Email</span
                  >
                      <span class="forgotPasswordSpan"
                      >An email with a verification link has been sent to
                    <span style="font-weight: bold">{{
                        this.emailOnResetPassword
                      }}</span
                    >. Please check your junk mail to ensure you receive it.</span
                      >
                      <span
                        slot="footer"
                        class="dialog-footer forgotPasswordInputSpanBtn"
                      >
                    <el-button
                      class="forgotPasswordBtn"
                      type="primary"
                      @click="handleCloseResetEmailSent"
                    >Close</el-button
                    >
                  </span>
                </el-dialog>
              </el-col>
            </el-row>
            <el-row class="sign-up-outer-wrapper">
              <el-col :span="24">
                <el-row  class="sign-up-divider-outer-wrapper">
                  <el-col :span="11" class="sign-up-divider-wrapper">
                    <div class="divider-start"></div>
                  </el-col>
                  <el-col :span="2" class="sign-up-divider-wrapper">
                    <div class="divider-mid">OR</div>
                  </el-col>
                  <el-col :span="11" class="sign-up-divider-wrapper">
                    <div class="divider-end"></div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="24">
                <el-row
                  :gutter="20"
                  style="display: flex;align-items: center; width: 100%"
                >
                  <el-col
                    :span="12"
                    style="padding-bottom: 16px; display: flex; justify-content: flex-end;"
                  >
                    <span class="sign-up-lbl font400">Not signed up?</span>
                  </el-col>
                  <el-col
                    :span="12"
                    style="padding-bottom: 16px; display: flex; justify-items: flex-start"
                  >
                    <el-button
                      class="btn-underline"
                      type="text"
                      @click="redirectToRegistration"
                    >Create an account
                    </el-button>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </el-col>

        </el-row>

      </div>
    </el-col>
  </el-row>
</template>

<style scoped>
.create-account-section {
  background-color: #0d0d0d;
  padding: 50px 16px;
}
.create-account-background {
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 0.5;
}

.sign-in-outer-wrapper {
  display: flex;
  justify-content: center;

  position: relative;
  padding: 20px 16px 30px 16px;
  background-color: transparent;
}
.sign-in-inner-wrapper {
  //min-width: 80%;
  //width: 80%;
}
.sign-in-title-wrapper {
  background-color: #003333;
  padding: 20px;
  border-radius: 15px 15px 0 0;
}
.icon-hide{
  width: 20px;
  height: 20px;
}
.sign-in-title {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 34px;
  font-style: normal;
  font-weight: 500;
  line-height: 117.647%;
  align-self: stretch;
}

.btn-primary {
  color: #ffffff;
  text-align: center;
  border: 3px solid #003333;
  background-color: #003333;
  padding: 14px 60px;
  font: 500 20px DINosaur-a, sans-serif;
}

.btn-underline {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  //border-bottom: 1px solid #fff;
}

.el-divider__text {
  background-color: #0d0d0d;
  //opacity: 0.7;
}


.forgotPasswordSpan {
  padding-bottom: 10px;
  white-space: normal;
  align-self: stretch;
  line-height: 125%;
  word-break: break-word;
  word-wrap: break-word;
}

.forgotPasswordInput {
  padding-top: 10px;
}

.forgotPasswordBtn {
  color: #ffffff;
  height: 54px;
  justify-content: center;
  white-space: normal;
  align-items: center;
  border-radius: 5px;
  border: 3px solid #003333;
  background-color: #003333;
  width: 260px;
  font: 500 20px DINosaur-a, sans-serif;
}

.el-dialog--center /deep/ .el-dialog__header {
  color: #003333;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 34px;
  font-style: normal;
  font-weight: 500;
  line-height: 117.647%;
}

.sign-up-lbl {
  color: #ffffff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: DINosaur-a;
  font-size: 16px;
  font-style: normal;
  line-height: 125%;
}

.sign-up-outer-wrapper {
}

.sign-up-divider-outer-wrapper {
  width: 100%;
  display: flex;
  margin-top: 14px;
  justify-content: space-between;
  gap: 20px;
}

.sign-up-divider-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}


.divider-start {
  background-color: #ffffff;
  align-self: center;
  min-width: 100%;
  max-width: 100%;
  height: 1px;
  margin: auto 0;
}

.divider-mid {
  color: #ffffff;
  font-feature-settings: "clig" off, "liga" off;
  font: 500 16px/125% DINosaur-a, sans-serif;
}

.divider-end {
  background-color: #ffffff;
  align-self: center;
  min-width: 100%;
  max-width: 100%;
  height: 1px;
  margin: auto 0;
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {

  .sign-in-title-wrapper {
    padding: 18px;
  }
  .sign-in-title {
    font-size: 25px;
    line-height: 70%;
  }
  .icon-hide{
    width: 10px;
    height: 10px;
  }
  .btn-primary {
    font-size: 16px;
    padding: 12px 60px;
  }

}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {

}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {

}
</style>



// WEBPACK FOOTER //
// src/components/login/signInSection.vue